module.exports = __webpack_public_path__ + "img/snow_fall_00036.fadb7941.png";